/**
 * Yeni rezervasyon bildirim canı — redux sabitleri.
 *
 * Servis sozlesmesi (backend devir belgesi):
 *   POST property/booking/notifications      -> tek tesis  (params.property_id zorunlu)
 *   POST property/booking/notifications-all  -> yetkili oldugu tum tesisler
 *   Yanit: { status, error, message, data: { latest_id, count, items[] } }
 *
 * Onemli: basari `error === false` ile anlasilir, `status === 1` ile DEGIL.
 */
export const bookingNotificationConstants = {
    BOOKING_NOTIFICATIONS_PENDING: 'BOOKING_NOTIFICATIONS_PENDING',
    BOOKING_NOTIFICATIONS_FULFILLED: 'BOOKING_NOTIFICATIONS_FULFILLED',
    BOOKING_NOTIFICATIONS_REJECTED: 'BOOKING_NOTIFICATIONS_REJECTED',

    // Menu KAPANINCA tetiklenir: cursor = latest_id ("gorulmus" say).
    BOOKING_NOTIFICATIONS_MARK_SEEN: 'BOOKING_NOTIFICATIONS_MARK_SEEN',

    // Toast gosterildikten sonra tetiklenir; ayni yigin ikinci kez toast edilmez.
    BOOKING_NOTIFICATIONS_TOAST_CLEAR: 'BOOKING_NOTIFICATIONS_TOAST_CLEAR',

    // Tesis degistiginde cursor sifirlanir (yeni kapsam, yeni izleme noktasi).
    BOOKING_NOTIFICATIONS_RESET: 'BOOKING_NOTIFICATIONS_RESET',
};

// Yoklama araligi — belgede sabitlenmis deger. Sekme arkadayken de surer.
export const BOOKING_NOTIFICATION_POLL_MS = 30000;

// Servis en fazla 20 satir doner; `count` gercek sayidir ve buyuk olabilir.
export const BOOKING_NOTIFICATION_PAGE_SIZE = 20;

// Rozette bu esigin ustu "9+" olarak gosterilir.
export const BOOKING_NOTIFICATION_BADGE_MAX = 9;

// Gorulmus kayitlar bellekte bu kadar tutulur; panel kapanip acilinca bosalmasin diye.
export const BOOKING_NOTIFICATION_SEEN_LIMIT = 20;

// Kalici bir hatada (yetki, kesinti, ag) 30 sn'de bir bosuna istek atmayalim:
// ust uste bu kadar hatadan sonra yoklama durur, panelden "Tekrar dene" ile acilir.
export const BOOKING_NOTIFICATION_MAX_FAILURES = 5;

// Asili kalan bir istek poller'i kilitlemesin.
export const BOOKING_NOTIFICATION_TIMEOUT_MS = 20000;
